import { render, staticRenderFns } from "./YcSelect.vue?vue&type=template&id=1b596cba&scoped=true&lang=pug&"
import script from "./YcSelect.vue?vue&type=script&lang=js&"
export * from "./YcSelect.vue?vue&type=script&lang=js&"
import style0 from "./YcSelect.vue?vue&type=style&index=0&id=1b596cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b596cba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
